import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { key: 2 }

import { onMounted, reactive, ref } from "vue";
import { MailService } from "@/api/services/MailService";
import { ListRequest } from "@/api/models/ListRequest";
import { message } from "ant-design-vue";
import dayjs from "dayjs";
import { ColumnType } from "ant-design-vue/lib/table";
import { Mail } from "@/api/models/mail/Mail";
import { MailAddRequest } from "@/api/models/mail/MailAddRequest";
import { MailUpdateRequest } from "@/api/models/mail/MailUpdateRequest";
import { ToImage } from "@/utils/image";


export default /*@__PURE__*/_defineComponent({
  __name: 'MailView',
  setup(__props) {

const total = ref<number>(0);

const listRequest = reactive<ListRequest>({
  current: 1,
  size: 20,
  content: "",
});

const mailList = ref<Mail[]>([]);

const handleList = async () => {
  const res = await MailService.ListAll(listRequest);
  if (res.code === 0) {
    mailList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error(res.msg);
  }
};

onMounted(async () => {
  await handleList();
});

const handleSizeChange = (current: number, pageSize: number) => {
  listRequest.current = current;
  listRequest.size = pageSize;
  handleList();
};

const handleChange = (page: number, pageSize: number) => {
  listRequest.current = page;
  listRequest.size = pageSize;
  handleList();
};

const openAdd = ref(false);

const addRequest = reactive<MailAddRequest>({
  name: "",
  level: 1,
  price: 0,
  content: "",
});

const submitAdd = async () => {
  const res = await MailService.Add(addRequest);
  if (res.code === 0) {
    message.success("添加成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const openUpdate = ref(false);

const updateRequest = reactive<MailUpdateRequest>({
  id: 0,
  name: "",
  level: 1,
  price: 0,
  content: "",
  is_delete: 1,
});

const handleUpdate = (record: Mail) => {
  openUpdate.value = true;
  Object.assign(updateRequest, record);
};

const submitUpdate = async () => {
  const res = await MailService.Update(updateRequest);
  if (res.code === 0) {
    message.success("修改成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitDelete = async (record: Mail) => {
  const res = await MailService.Delete(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const submitDrop = async (record: Mail) => {
  const res = await MailService.Drop(record.id);
  if (res.code === 0) {
    message.success("删除成功");
    setTimeout(() => location.reload(), 1000);
  } else {
    message.error(res.msg);
  }
};

const columns: ColumnType[] = [
  {
    title: "Id",
    dataIndex: "id",
    align: "center",
  },
  {
    title: "轮播名称",
    dataIndex: "name",
    align: "center",
  },
  {
    title: "优先级",
    dataIndex: "level",
    align: "center",
  },
  {
    title: "价格",
    dataIndex: "price",
    align: "center",
  },
  {
    title: "弹窗内容",
    dataIndex: "content",
    align: "center",
  },
  {
    title: "状态",
    dataIndex: "is_delete",
    align: "center",
  },
  {
    title: "创建时间",
    dataIndex: "create_at",
    align: "center",
  },
  {
    title: "操作",
    dataIndex: "operator",
    align: "center",
  },
];

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_button, {
      type: "primary",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (openAdd.value = true)),
      style: {"margin-bottom":"16px"}
    }, {
      default: _withCtx(() => _cache[12] || (_cache[12] = [
        _createTextVNode(" 添加快递配置 ")
      ])),
      _: 1
    }),
    _createVNode(_component_a_table, {
      columns: columns,
      "data-source": mailList.value,
      pagination: {
        current: listRequest.current,
        pageSize: listRequest.size,
        total: total.value,
        showSizeChanger: true,
        pageSizeOptions: [10, 20, 30, 40, 50],
        onChange: handleChange,
        onShowSizeChange: handleSizeChange,
      },
      bordered: ""
    }, {
      bodyCell: _withCtx(({ column, record }: { column: ColumnType, record: Mail }) => [
        (column.dataIndex === 'is_delete')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (record.is_delete === 1)
                ? (_openBlock(), _createBlock(_component_a_tag, {
                    key: 0,
                    color: "green"
                  }, {
                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                      _createTextVNode("正常")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (record.is_delete === 2)
                ? (_openBlock(), _createBlock(_component_a_tag, {
                    key: 1,
                    color: "red"
                  }, {
                    default: _withCtx(() => _cache[14] || (_cache[14] = [
                      _createTextVNode("回收站")
                    ])),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], 64))
          : (column.dataIndex === 'image_url')
            ? (_openBlock(), _createBlock(_component_a_image, {
                key: 1,
                src: _unref(ToImage)(record.image_url),
                style: {"height":"60px","width":"auto"}
              }, null, 8, ["src"]))
            : (column.dataIndex === 'create_at')
              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(dayjs)(record.create_at).format("YYYY-MM-DD HH:mm:ss")), 1))
              : (column.dataIndex === 'operator')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createVNode(_component_a_button, {
                      onClick: ($event: any) => (handleUpdate(record)),
                      type: "primary",
                      style: { marginRight: '8px' }
                    }, {
                      default: _withCtx(() => _cache[15] || (_cache[15] = [
                        _createTextVNode("编辑 ")
                      ])),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_a_button, {
                      onClick: ($event: any) => (submitDelete(record)),
                      type: "primary",
                      style: {
              backgroundColor: '#ff7a45',
              color: 'white',
              marginRight: '8px',
            }
                    }, {
                      default: _withCtx(() => _cache[16] || (_cache[16] = [
                        _createTextVNode("删除 ")
                      ])),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_a_button, {
                      onClick: ($event: any) => (submitDrop(record)),
                      type: "primary",
                      style: {
              backgroundColor: '#ff4d4f',
              color: 'white',
            }
                    }, {
                      default: _withCtx(() => _cache[17] || (_cache[17] = [
                        _createTextVNode("彻底删除 ")
                      ])),
                      _: 2
                    }, 1032, ["onClick"])
                  ], 64))
                : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["data-source", "pagination"]),
    _createVNode(_component_a_modal, {
      open: openAdd.value,
      "onUpdate:open": _cache[5] || (_cache[5] = ($event: any) => ((openAdd).value = $event)),
      title: "添加快递数据",
      onOk: submitAdd,
      cancelText: "取消"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, { model: addRequest }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "快递名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: addRequest.name,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((addRequest.name) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "优先级" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_number, {
                  value: addRequest.level,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((addRequest.level) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "价格" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_number, {
                  value: addRequest.price,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((addRequest.price) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "内容" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: addRequest.content,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((addRequest.content) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["open"]),
    _createVNode(_component_a_modal, {
      open: openUpdate.value,
      "onUpdate:open": _cache[11] || (_cache[11] = ($event: any) => ((openUpdate).value = $event)),
      title: "修改快递数据",
      onOk: submitUpdate,
      cancelText: "取消"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          model: updateRequest,
          style: {"margin-top":"20px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "快递名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: updateRequest.name,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((updateRequest.name) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "优先级" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_number, {
                  value: updateRequest.level,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((updateRequest.level) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "价格" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_number, {
                  value: updateRequest.price,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((updateRequest.price) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "内容" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  value: updateRequest.content,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((updateRequest.content) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: updateRequest.is_delete,
                  "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((updateRequest.is_delete) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_select_option, { value: 1 }, {
                      default: _withCtx(() => _cache[18] || (_cache[18] = [
                        _createTextVNode("正常")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_select_option, { value: 2 }, {
                      default: _withCtx(() => _cache[19] || (_cache[19] = [
                        _createTextVNode("回收站")
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ]),
      _: 1
    }, 8, ["open"])
  ]))
}
}

})